import { Injectable } from '@angular/core';
import { CurrencyUnit } from '@pdqdev/pdq-shared/dist/entities';
import { convertPriceToCurrency } from '@pdqdev/pdq-shared/dist/utils';

import { ApiService } from '../../core/services/api/api.service';
import { CurrencyRate } from './currency-rate.model';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CurrencyRatesService {
  constructor(private apiService: ApiService) {}

  getLatestCurrencyRates(): Promise<CurrencyRate[]> {
    return this.apiService.promissedGet('currency-rates/latest');
  }

  getCurrencyRatesByDate(date: string): Promise<CurrencyRate[]> {
    return this.apiService.promissedGet('currency-rates/' + date);
  }

  getCurrencyRatesFromToDates(fromDate: string, toDate: string, currencies: string[]): Promise<CurrencyRate[]> {
    let params = new HttpParams().set('fromDate', fromDate).set('toDate', toDate);

    if (currencies?.length) {
      currencies.forEach((curr) => {
        params = params.append('currency', curr);
      });
    }

    return this.apiService.promissedGet(`currency-rates`, { params });
  }

  getConvertedPrice(
    price: number,
    from: CurrencyUnit = 'USD',
    to: CurrencyUnit = 'USD',
    latestCurrencyRates: CurrencyRate[] = [],
  ): string {
    return convertPriceToCurrency(price, from, to, latestCurrencyRates);
  }
}
